import { render } from "./cambioContrasenia.vue?vue&type=template&id=1a8f9c1d&scoped=true"
import script from "./cambioContrasenia.vue?vue&type=script&lang=js"
export * from "./cambioContrasenia.vue?vue&type=script&lang=js"

import "./cambioContrasenia.vue?vue&type=style&index=0&id=1a8f9c1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8f9c1d"]])

export default __exports__